<template>
    <div class="container-fluid">
        <div class="card card-default custom-card-height">
            <div class="card-header feature-header">
                <div class="row g-2">
                    <div class="col-auto me-auto">
                        <CardTitleComponent />
                    </div>
                    <div class="col-auto">
                        <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
                    </div>

                    <div class="col-auto">
                        <a class="btn btn-outline-primary" @click="open(true)">
                            <i class="fas fa-plus me-1"></i>{{ $t('addNew') }}
                        </a>
                    </div>
                </div>

            </div>
            <div class="card-body p-2">
                <div class="card-body-grid">
                    <ejs-grid ref="gridsubscription" :dataSource="data" :allowPaging="true" :allowResizing='true'
                        :pageSettings='pageSettings' :locale='locale' :rowHeight='38' :allowSorting='true' height="100%"
                        :searchSettings='searchOptions' :dataStateChange='dataStateChange'>
                        <e-columns>
                            <e-column :headerText="$t('organization') + ' ' + $t('name')" field='OrganizationName'
                                width='100'></e-column>
                            <e-column :headerText="$t('server') + ' ' + $t('name')" field='ServerName'
                                width='80'></e-column>
                            <e-column :headerText="$t('database') + ' ' + $t('name')" field='dbName'
                                width='100'></e-column>
                            <e-column :headerText="$t('subscriber') + ' ' + $t('type')" field='SubscriberType'
                                width='100'></e-column>
                            <e-column :headerText="$t('modules')" field='modules' :allowSorting="false"
                                :template="'moduleTemplate'">
                                <template v-slot:moduleTemplate="{ data }">
                                    <ejs-chiplist v-for="(chipItem, index) in data.modules" :id="'chip' + index"
                                        :text="chipItem.name"></ejs-chiplist>
                                </template>
                            </e-column>
                            <e-column :headerText="$t('actions')" width='90' textAlign="Center" :template="'actionTemplate'">
                                <template v-slot:actionTemplate="{ data }">
                                    <div class="btn-group actions-row" role="group" aria-label="Basic example">
                                        <a href="javascript:void(0)" class="ms-2 action-link" title="Sync Activation"
                                            @click="commandClick('Sync activation', data)">
                                            <i class="e-repeat e-icons" style="font-size: 0.76em;"></i>
                                        </a>
                                        <a href="javascript:void(0)" class="ms-2 action-link action-edit" title="Edit"
                                            @click="commandClick('Edit', data)">
                                            <i class="e-edit e-icons" style="font-size: 0.76em;"></i>
                                        </a>
                                        <a href="javascript:void(0)" class="ms-2 action-link action-delete" title="Delete"
                                            @click="commandClick('Delete', data)">
                                            <i class="e-delete e-icons" style="font-size: 0.76em;"></i>
                                        </a>
                                    </div>
                                </template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <ConfirmComponent :title="confirmTitle" :is-subscription="true"
                    :subscription-delete-title="$t('subscriptionDeleteConfirm')" @yes="commandConfirm" />
            </div>
        </div>
    </div>
    <div class="modal fade" id="subscriptionModal" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t('customer') }}</h4>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                        @click="close('subscriptionModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <RegisterModalComponent :-is-subscription="true" :-is-update="isUpdate" :form="form" />
            </div>
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="subscriptionModuleSyncModal" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t('syncActivation') }} - ({{ syncConfigurationForm.organizationName }})
                    </h4>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                        @click="close('subscriptionModuleSyncModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th class="col-6">{{ $t('module') }}</th>
                                <th class="col-6"></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(module, index) of syncConfigurationForm.modules" :key="module.id">
                                <td class="col-6">
                                    {{ module.name }}
                                </td>
                                <td class="col-6">
                                    <ejs-checkbox :id="'module' + index" v-model="module.isSyncActive"
                                        @change="onSyncStatusChange(syncConfigurationForm.id, module)"></ejs-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /.modal-dialog -->
    </div>
    <input id="subsWiseRegister" @change="changeEffect()" type="hidden" />
</template>

<script lang="ts">
import './SubscriptionComponent.css';
import { GridComponent as EjsGrid, ColumnsDirective as EColumns, ColumnDirective as EColumn, Resize, Toolbar, Page, Group, Sort, Search }
    from '@syncfusion/ej2-vue-grids';
import { defineComponent } from 'vue';
import modal from '@/components/common/modalManage';
import staticMessage from '@/components/common/staticMessage';
import ConfirmComponent from '@/components/molecules/ConfirmComponent.vue';
import agent, { masterServiceBaseURL } from '@/services/agent';
import toasterService from '@/services/toasterService';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import { Subscription, SubscriptionGetResponse, SubscriptionResponse, Property, SyncConfigurationForm, SyncActivationResponse } from './Subscription.model';
import RegisterModalComponent from '../Register/RegisterModalComponent.vue';
import SubsriberType from '../../common/SubsriberTypeEnum';
import { CheckBoxComponent, ChipListComponent } from '@syncfusion/ej2-vue-buttons';
import emitter from '@/services/mitt';
import _ from 'lodash';
import { CommonResponse } from '@/components/common/model';
import { Module } from '../Module/Module.model';
import CardTitleComponent from '@/components/common/CardTitleComponent.vue';
import SearchComponent from '@/components/shared/SearchComponent.vue';

let _subscriptionData: Property = {} as Property;
let _subscriptionForm: Subscription = {} as Subscription;
let _syncConfigurationForm: SyncConfigurationForm = {} as SyncConfigurationForm;

export default defineComponent({
    components: {
        "ejs-grid": EjsGrid,
        "e-columns": EColumns,
        "e-column": EColumn,
        'ejs-chiplist': ChipListComponent,
        ConfirmComponent,
        RegisterModalComponent,
        "ejs-checkbox": CheckBoxComponent,
        CardTitleComponent,
        SearchComponent,
    },
    provide: {
        grid: [Toolbar, Resize, Page, Sort, Group]
    },
    created() {
        agent.setBaseUrl(masterServiceBaseURL);
        this.gridLocalize();
    },
    data() {
        return {
            data: _subscriptionData,
            form: _.clone(_subscriptionForm),
            syncConfigurationForm: _.clone(_syncConfigurationForm),
            isUpdate: false,
            confirmTitle: "",
            confirmIsDelete: false,
            selectedState: null,
            isLoading: false,
            showRegisterModal: false,
            organizationName: "",
            searchText: '',
            searchOptions: { fields: ['OrganizationName'], operator: 'contains', ignoreCase: true },
            pageSettings: {
                pageSizes: [10, 20, 50, 100],
                pageSize: 50,
                pageCount: 5,
                skip: 0,
                take: 50
            },
            locale: ''
        }
    },
    mounted() {
        this.isLoading = true;
        this.dataStateChange(this.initState(this.pageSettings.skip, this.pageSettings.take));
        emitter.on('changeSubscriptions', () => {
            this.changeEffect();
        });
    },
    methods: {
        initState(skip: number = 0, take: number): any {
            let state = {
                skip: skip,
                take: take
            };
            return state;
        },
        dataStateChange(state: any) {
            this.gridLocalize();
            this.loadSubscription(state);
        },
        loadSubscription(state: any) {
            if (state.action) {
                delete state.action;
            }

            const gridsubscription: any = this.$refs.gridsubscription;
            if (gridsubscription) gridsubscription.hideSpinner();

            agent.post<SubscriptionGetResponse>(`v1/subscription/getsubscription`, state).then((response) => {
                if (response.result) {
                    this.data = response.result;
                    this.data.result.map(i => {
                        if (parseInt(i.subscriberType) == 0) {
                            i.subscriberType = SubsriberType.Host.name;
                        } else {
                            i.subscriberType = SubsriberType.Tenant.name;
                        }
                    });
                }
            }).catch(() => { });
        },
        onDelete(isSubsDelete: boolean) {
            let put = {
                id: this.form.id,
                isSubsDelete: isSubsDelete
            };

            modal.Close(staticMessage.modalConfirm);
            agent.delete<SubscriptionResponse>(`v1/subscription`, put).then((response) => {
                if (response.result) {
                    toasterService.success(this.$t("msgDelete"));
                    this.loadSubscription(this.initState(this.pageSettings.skip, this.pageSettings.take));
                    this.resetSubscription();
                }
            }).catch(() => { });
        },
        changeEffect() {
            if (this.isUpdate) toasterService.success(this.$t("msgUpdate"));
            else toasterService.success(this.$t("msgSave"));

            this.loadSubscription(this.initState(this.pageSettings.skip, this.pageSettings.take));
            this.resetSubscription();
            this.close('subscriptionModal');
        },
        resetSubscription() {
            this.form = {} as Subscription;
            this.isUpdate = false;
        },
        commandConfirm(data: any) {
            if (this.confirmIsDelete) {
                this.onDelete(data.isSubsDelete);
                this.confirmIsDelete = false;
            }
        },
        commandClick: function (type: string, data: Subscription) {
            this.isUpdate = true;
            switch (type) {
                case 'Sync activation':
                    this.getModules(data);
                    break;
                case 'Edit':
                    this.form = data;
                    this.showRegisterModal = true;
                    emitter.emit('setForm', this.form);
                    modal.Open('subscriptionModal');
                    break;
                case 'Delete':
                    if (String(data.subscriberType).toLowerCase() == SubsriberType.Host.name.toLowerCase()) {
                        toasterService.warn(this.$t("Unable to delete host!"));
                        return;
                    }
                    this.confirmTitle = `Are you sure want to delete?`;
                    this.form.id = data.id;
                    this.confirmIsDelete = true;
                    modal.Open(staticMessage.modalConfirm);
                    break;
                default: break;
            }
        },
        gridLocalize() {
            this.locale = 'en-grid';
            if (this.$i18n.locale == 'se') {
                setTimeout(() => {
                    import(`@/assets/sv.json`).then(module => {
                        const localText = module.default;
                        this.locale = 'sv';
                        setCulture('sv');
                        L10n.load(localText);
                    });
                });
            }
        },
        open() {
            this.form = {} as Subscription;
            this.isUpdate = false;
            this.showRegisterModal = true;
            document.getElementById('subsWiseModulesId')!.dispatchEvent(new Event('change'));
            modal.Open('subscriptionModal');
        },
        close(modalType: string) {
            this.form = {} as Subscription;
            modal.Close(modalType);
        },
        onSearch() {
            const grid = (this.$refs.gridsubscription as any)?.ej2Instances;
            if (grid) grid.search(this.searchText);
        },
        clearSearch() {
            this.searchText = '';
            const grid = (this.$refs.gridsubscription as any)?.ej2Instances;
            if (grid) grid.search('');
        },
        getModules(sub: Subscription) {
            this.syncConfigurationForm = {} as SyncConfigurationForm;
            this.syncConfigurationForm.id = sub.id;
            this.syncConfigurationForm.organizationName = sub.organizationName;
            agent.get<CommonResponse<Module>>(`v1/Module/GetModules?subscriptionId=${sub.id}`).then((response) => {
                if (response.result) {
                    this.syncConfigurationForm.modules = response.result.map((module: Module) => {
                        return {
                            id: module.id,
                            name: module.displayName,
                            isSyncActive: module.isSyncActive || false // Ensure isSyncActive is set
                        };
                    });
                    modal.Open('subscriptionModuleSyncModal');
                }
            }).catch(() => {
                toasterService.error(this.$t("msgError"));
            });
        },
        onSyncStatusChange(subscriptionId: string, module: any) {
            this.data.result = this.data.result.map((item: Subscription) => {
                if (item.id === subscriptionId) {
                    item.modules = item.modules.map((m: any) => {
                        if (m.id === module.id) {
                            m.isSyncActive = !m.isSyncActive; // Toggle the sync status
                        }
                        return m;
                    });
                }
                return item;
            });

            let post = {
                subscriptionId: subscriptionId,
                moduleId: module.id,
                isSyncActive: module.isSyncActive
            };
            agent.post<SyncActivationResponse>(`v1/subscription/ModuleWiseSyncActivation`, post).then((response) => {
                if (response.result) {
                    toasterService.success(this.$t("msgUpdate"));
                }
            }).catch(() => {
                module.isSyncActive = !module.isSyncActive; // Revert the change if the request fails
                toasterService.error(this.$t("msgError"));
            });
        }
    }
});
</script>
